"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _reactI18next = require("react-i18next");
var _styles = require("@mui/material/styles");
var Loading = function Loading(_ref) {
  var message = _ref.message;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      height: '100vh',
      widht: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.palette.background.paper
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    sx: {
      position: 'relative',
      color: theme.palette.text.primary
    }
  }, " ", t(message), " "), /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null));
};
exports.Loading = Loading;